import dynamic from 'next/dynamic';
const DashboardFilterModal = dynamic(() => import('./dashboardFilterModal'), {
    ssr: false,
});
export default DashboardFilterModal;
